// src/locales/ta/supplier.js
export const supplier = {
  // Page title and descriptions
  manageSuppliers: 'விநியோகஸ்தர்களை நிர்வகிக்கவும்',
  viewAndManageSuppliers: 'உங்கள் விநியோகஸ்தர் உறவுகளைப் பார்வையிடவும் மற்றும் நிர்வகிக்கவும்',

  // Statistics
  totalSuppliers: 'மொத்த விநியோகஸ்தர்கள்',
  activeSuppliers: 'செயலில் உள்ள விநியோகஸ்தர்கள்',
  inactiveSuppliers: 'செயலற்ற விநியோகஸ்தர்கள்',

  // Actions
  createNewSupplier: 'புதிய விநியோகஸ்தரை உருவாக்கவும்',
  createFirstSupplier: 'உங்கள் முதல் விநியோகஸ்தரை உருவாக்கவும்',
  editSupplier: 'விநியோகஸ்தரைத் திருத்தவும்',
  deleteSupplier: 'விநியோகஸ்தரை நீக்கவும்',
  createSupplier: 'விநியோகஸ்தரை உருவாக்கவும்',
  updateSupplier: 'விநியோகஸ்தரை புதுப்பிக்கவும்',

  // Fields
  supplierName: 'விநியோகஸ்தரின் பெயர்',
  contactPerson: 'தொடர்பு நபர்',
  email: 'மின்னஞ்சல்',
  phone: 'தொலைபேசி',
  address: 'முகவரி',
  city: 'நகரம்',
  country: 'நாடு',
  taxId: 'வரி அடையாள எண் / NTN',
  paymentTerms: 'கட்டண நிபந்தனைகள்',
  creditLimit: 'கடன் வரம்பு',
  notes: 'குறிப்புகள்',

  // Placeholders
  enterSupplierName: 'விநியோகஸ்தர் நிறுவனத்தின் பெயரை உள்ளிடவும்',
  enterContactPerson: 'தொடர்பு நபரின் பெயரை உள்ளிடவும்',
  enterEmail: 'மின்னஞ்சல் முகவரியை உள்ளிடவும்',
  enterPhone: 'தொலைபேசி எண்ணை உள்ளிடவும்',
  enterAddress: 'உண்மையான முகவரியை உள்ளிடவும்',
  enterCity: 'நகரத்தை உள்ளிடவும்',
  enterCountry: 'நாட்டை உள்ளிடவும்',
  enterTaxId: 'வரி அடையாள எண்ணை உள்ளிடவும்',
  enterPaymentTerms: 'உதா., Net 30, COD',
  enterCreditLimit: 'கடன் வரம்பை உள்ளிடவும்',
  enterNotes: 'விநியோகஸ்தர் பற்றிய கூடுதல் குறிப்புகள்...',

  // Search and filters
  searchSuppliers: 'பெயர், தொடர்பு, மின்னஞ்சல் அல்லது தொலைபேசி மூலம் தேடவும்...',
  allStatuses: 'அனைத்து நிலைகள்',
  filterByCity: 'நகரத்தின் அடிப்படையில் வடிகட்டவும்',
  filterByCountry: 'நாட்டின் அடிப்படையில் வடிகட்டவும்',

  // Messages
  supplierCreatedSuccessfully: 'விநியோகஸ்தர் வெற்றிகரமாக உருவாக்கப்பட்டார்',
  supplierUpdatedSuccessfully: 'விநியோகஸ்தர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்',
  supplierDeletedSuccessfully: 'விநியோகஸ்தர் வெற்றிகரமாக நீக்கப்பட்டார்',
  supplierMarkedAsInactive: 'விநியோகஸ்தர் செயலற்றதாக குறிக்கப்பட்டார்',
  failedToLoadSuppliers: 'விநியோகஸ்தர்களை ஏற்ற முடியவில்லை',
  failedToCreateSupplier: 'விநியோகஸ்தரை உருவாக்க முடியவில்லை',
  failedToUpdateSupplier: 'விநியோகஸ்தரை புதுப்பிக்க முடியவில்லை',
  failedToDeleteSupplier: 'விநியோகஸ்தரை நீக்க முடியவில்லை',

  // Empty states
  noSuppliersYet: 'விநியோகஸ்தர்கள் இல்லை',
  noSuppliersYetDescription: 'உங்கள் முதல் விநியோகஸ்தரை உருவாக்கி தொடங்குங்கள்.',
  noSuppliersFound: 'விநியோகஸ்தர்கள் எதுவும் கிடைக்கவில்லை',
  noSuppliersFoundDescription: 'உங்கள் தேடல் அளவுருக்களுக்கு பொருந்தும் விநியோகஸ்தர்கள் இல்லை. வடிகட்டல்களை மாற்றிப் பார்க்கவும்.',

  // Delete confirmation
  confirmDelete: '"{{name}}" ஐ நீக்க விரும்புகிறீர்களா?',
  deleteWarning: 'இந்த விநியோகஸ்தருடன் தொடர்புடைய கொள்முதல் ஆர்டர்கள் இருந்தால், அது நிரந்தரமாக நீக்கப்படாது, செயலற்றதாக குறிக்கப்படும்.',

  // Validation
  validation: {
    nameRequired: 'விநியோகஸ்தரின் பெயர் தேவை',
    invalidEmail: 'தவறான மின்னஞ்சல் வடிவம்',
    invalidCreditLimit: 'கடன் வரம்பு ஒரு செல்லுபடியாகும் நேர்ம எண்ணாக இருக்க வேண்டும்',
    fixErrors: 'படிவத்தில் உள்ள பிழைகளை சரிசெய்யவும்',
  },
  activeHint: "புதிய கொள்முதல் ஆர்டர்களில் சப்ளையரைத் தேர்ந்தெடுக்கலாம்",
  inactiveHint: "புதிய கொள்முதல் ஆர்டர்களில் சப்ளையர் மறைக்கப்பட்டுள்ளார்",
};
